<template>
  <CollapseSection
    title="Dados do tomador"
    :expanded="expanded"
    :loading="loading"
    section-id="dados_tomador"
    @toggleSection="$emit('toggleSection')"
  >
    <div class="pb-5">
        <div v-if="alertMessage">
            <b-alert show :variant="alertVariant">{{ alertMessage }}</b-alert>
        </div>

        <div class="row">
            <!-- Dados Grupo Economico -->
            <div class="col-12 col-lg-6 mb-3 pr-md-4">
                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="economic_group_cnpj">CNPJ</label>
                        <b-form-input class="form-control" id="economic_group_cnpj"
                            v-if="editable" v-model="dataFormEconomicGroup.economic_group_cnpj" v-mask="'XX.XXX.XXX/XXXX-##'"
                            @change="onChangeCompanyCnpj"
                            placeholder="Digite o CNPJ da empresa">
                        </b-form-input>
                        <p v-else>
                            {{  formatCnpj(dataFormEconomicGroup.economic_group_cnpj)  }}
                            <CopyButton :value="dataFormEconomicGroup.economic_group_cnpj" />
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="group_name">Nome do Grupo</label>
                        <b-form-input class="form-control" id="group_name" 
                            v-if="editable" v-model="dataFormEconomicGroup.group_name" @change="storeEconomicGroup"
                            placeholder="Digite o nome da empresa">
                        </b-form-input>
                        <p v-else>{{  dataFormEconomicGroup.group_name  }}</p>
                    </div>
                </div>
            </div>

            <!-- Dados Bancário -->
            <div class="col-12 col-lg-6 pl-md-4 border-left">
                <div class="row">
                    <div class="col-12 col-lg-6 mb-3">
                        <label class="dbo-ui" for="bank">Banco</label>
                        <input type="text" id="banco" class="form-control" placeholder="" 
                            v-if="editable" v-model="dataFormEconomicGroupBank.bank" @change="storeEconomicGroupBank" :disabled="disabled" />
                        <p v-else>
                            <span v-html="getHtmlEmptyText(dataFormEconomicGroupBank.bank)"></span>
                            <CopyButton :value="dataFormEconomicGroupBank.bank" />
                        </p>
                    </div>
                    <div class="col-12 col-lg-6 mb-3">
                        <label class="dbo-ui" for="agencia">Agência</label>
                        <input type="text" id="agencia" class="form-control" placeholder="" 
                            v-if="editable" v-model="dataFormEconomicGroupBank.agency" @change="storeEconomicGroupBank" :disabled="disabled" />
                        <p v-else>
                            <span v-html="getHtmlEmptyText(dataFormEconomicGroupBank.agency)"></span>
                            <CopyButton :value="dataFormEconomicGroupBank.agency" />
                        </p>
                    </div>
                    <div class="col-12 col-lg-6 mb-3">
                        <label class="dbo-ui" for="conta_corrente">Conta corrente</label>
                        <input type="text" id="conta_corrente" class="form-control" placeholder="" 
                            v-if="editable" v-model="dataFormEconomicGroupBank.current_account" @change="storeEconomicGroupBank" :disabled="disabled" />
                        <p v-else>
                            <span v-html="getHtmlEmptyText(dataFormEconomicGroupBank.current_account)"></span>
                            <CopyButton :value="dataFormEconomicGroupBank.current_account" />
                        </p>
                    </div>
                    <div class="col-12 col-lg-6 mb-3">
                        <label class="dbo-ui" for="chave_pix">Chave PIX</label>
                        <input type="text" id="chave_pix" class="form-control" placeholder="" 
                            v-if="editable" v-model="dataFormEconomicGroupBank.pix_key" @change="storeEconomicGroupBank" :disabled="disabled" />
                        <p v-else>
                            <span v-html="getHtmlEmptyText(dataFormEconomicGroupBank.pix_key)"></span>
                            <CopyButton :value="dataFormEconomicGroupBank.pix_key" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal">
        <b-modal id="show-modal-list-groups" ref="showModalListGroups"
            size="lg" centered
            no-close-on-esc no-close-on-backdrop
            hide-header-close hide-footer>

            <template #modal-title>Editar tomador</template>

            <div class="card card-termo-uso mb-3">
                <p class="mb-4">
                    O CNPJ informado foi encontrado nos seguintes grupos econômicos.<br />
                    Escolha qual você deseja editar ou inicie um novo cadastro:
                </p>
            
                <div class="lista">
                    <div class="row row-cols-1" data-modelo="cards">
                        <div class="col mb-3">
                            <div class="card shadow border-1 mb-2"
                                v-for="(economicGroup, index) in listEconomicGroupRegistered" :key="index">
                                <div class="card-body text-left d-flex align-items-center px-3 py-2">
                                    <div class="">
                                        <h6 class="mb-1 pr-3">{{ economicGroup.group_name }}</h6>
                                        <span class="font-14 text-primary">{{ formatCnpj(economicGroup.economic_group_cnpj) }}</span>
                                    </div>
                                    <div class="ml-auto">
                                        <button data-dismiss="modal" type="button" class="button btn btn-outline-primary py-2 nowrap"
                                        @click="redirectEconomicGroup( economicGroup.id )">
                                            Editar <i class="fas fa-edit ml-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row border-top py-4">
                <div class="col-12 col-lg-12 d-flex justify-content-end">
                    <button class="btn btn-primary" @click="redirectEconomicGroup()">
                        <i class="fa fa-check mr-1"></i> Novo cadastro
                    </button>
                </div>
            </div>
        </b-modal>
    </div>

  </CollapseSection>
</template>

<script>
import { CollapseSection } from '@/components';
import { mask } from "vue-the-mask";
import commomsHelperMixin from "@/mixins/commomsHelper";
import uiHelperMixin from "@/mixins/uiHelper";
import commonsService from "@/services/commons";
import companyService from "@/services/company";
import economicGroupService from "@/services/economic-group";

export default {
    components: { CollapseSection },
    props: {
        expanded: Boolean,
        disabled: Boolean,
        economicGroupID: String,
        editable: { type: Boolean, default: false }
    },
    mixins: [commomsHelperMixin, uiHelperMixin],
    directives: { mask, },
    data: () => ({
        loading: false,
        dataFormEconomicGroup: {
            cnpj: '',
            economic_group_cnpj: '',
            group_name: '',
            company_name: '',
            address: '',
            commercial_id: ''
        },
        dataFormEconomicGroupBank: {
            bank: '',
            agency: '',
            current_account: '',
            pix_key: '',
        },
        listEconomicGroupRegistered: []
    }),
    created() {
        if (this.economicGroupID) {
            this.findData();
        }
    },
    methods: {
        findData() {
            if (this.economicGroupID) {
                this.getBankDetail();
                this.getEconomicGroup();
            }
        },
        getEconomicGroup() {
            this.loading = true;
            companyService
                .showEconomicGroup( this.economicGroupID, {shortVersion: true})
                .then((response) => {
                    if (response.data.error) {
                        this.showError(response.data.message);
                        return;
                    }
                    this.dataFormEconomicGroup = response.data;
                })
                .catch((error) => {
                    this.showError(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getBankDetail() {
            this.loading = true;
            economicGroupService
                .getBankDetail( this.economicGroupID )
                .then((response) => {
                    if (response.data.error) {
                        return;
                    }
                    Object.assign(
                        this.dataFormEconomicGroupBank,
                        response.data
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onChangeCompanyCnpj: function (cnpj) {
            if (cnpj.length == 18) {
                this.loading = true;
                cnpj = this.traitCnpj(cnpj);
                    
                economicGroupService
                    .getEconomicGroupFromCnpj(cnpj)
                    .then((response) => {
                        if (response.data.length > 0) {
                            this.openModalListGroups();
                            this.listEconomicGroupRegistered = response.data;
                            return;
                        }
                        
                        commonsService
                            .findCnpj(cnpj)
                            .then((response) => {
                                if (response.data.error) {
                                    return;
                                }

                                this.dataFormEconomicGroup.group_name = response.data.name;
                                this.dataFormEconomicGroup.company_name = response.data.name;
                                this.dataFormEconomicGroup.address = response.data.address;
                            })
                            .finally(() => {
                                this.loading = false;
                                this.storeEconomicGroup();
                            });
                    })
                    .catch((error) => {
                        this.showError(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        openModalListGroups() {
            this.$refs.showModalListGroups.show();
        },
        redirect(routeName, params = {}) {
            this.$router.push({name: routeName, params: params})
        },
        redirectEconomicGroup(economicGroupID, reload = true) {
            if (!economicGroupID) { // novo
                if (this.$route.name == 'client-store') {
                    this.$router.go(0);
                    return;
                }
                this.redirect('client-store');
                return;
            }

            if (
                this.$route.name == 'update-client'
                && this.$route.params.economicGroupID
                && this.$route.params.economicGroupID == economicGroupID
                && reload
            ) {
                this.$router.go(0);
                return;
            }
            
            this.redirect('update-client', {economicGroupID: economicGroupID});
            return;
        },
        storeEconomicGroup() {
            this.dataFormEconomicGroup.cnpj = this.dataFormEconomicGroup.economic_group_cnpj;
            this.dataFormEconomicGroup.company_name = this.dataFormEconomicGroup.company_name
                || this.dataFormEconomicGroup.group_name;

            if (this.dataFormEconomicGroup.cnpj != '' && this.dataFormEconomicGroup.group_name != '') {
                this.loading = true;

                if (this.economicGroupID) {
                    economicGroupService
                        .updateEconomicGroup(this.economicGroupID, this.dataFormEconomicGroup)
                        .then((response) => {
                            if (response.data.error) {
                                this.showError(response.data.message);
                                return;
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });

                } else {
                    economicGroupService
                        .storeEconomicGroup(this.dataFormEconomicGroup)
                        .then((response) => {
                            if (response.data.error) {
                                this.showError(response.data.message);
                                return;
                            }
    
                            const economicGroupId = response.data.id;
                            if (this.economicGroupID != economicGroupId) {
                                this.redirectEconomicGroup(economicGroupId, false);
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
            
        },
        storeEconomicGroupBank() {
            if (this.economicGroupID) {
                economicGroupService
                    .storeEconomicGroupBank(this.economicGroupID, this.dataFormEconomicGroupBank)
                    .then((response) => {
                        if (response.data.error) {
                            this.showError(response.data.message);
                            return;
                        }
                    });

            }         
        },
        getHtmlEmptyText(text) {
            return text ? text : '<small><em>Não informado.</em></small>';
        }
    },
    watch: {
        expanded: function (value) {
            if (value) {
                this.resetAlert();
                this.findData();
            }
        },
    }
}
</script>

<style scoped>
#dropdown-comercial >>> .btn { border: 1px solid #ccc !important; border-radius: 0rem; }
#dropdown-comercial >>> .dropdown-menu { box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2) !important; }
#dropdown-comercial >>> .dropdown-toggle::after { position: absolute; right: 15px; top: 50%; }
#dropdown-comercial >>> .dropdown-item { display: flex; justify-content: space-between; align-items: center; }
#dropdown-comercial >>> .option-selected .dropdown-item { background-color: #edf4fa; color: #343a40; }
</style>